import React from 'react';
import { Route, Switch } from 'react-router';
import UnauthenticatedApp from './layout/UnauthenticatedApp';
import AuthenticatedApp from './layout/AuthenticatedApp';
import './index.css';

const App: React.FC = () => {
  return (
    <Switch>
      <Route path="/login" component={UnauthenticatedApp} />
      <Route path="/" component={AuthenticatedApp} />
    </Switch>
  );
};

export default App;
